<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-select
          v-model="formInline.platform_type"
          @change="handleSelectChange"
          class="handle-select mr10"
        >
          <el-option
            v-for="(child, index) in platform_type_list"
            :key="index"
            :label="child.label"
            :value="child.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="formInline.type"
          @change="handleSelectChange"
          class="handle-select mr10"
        >
          <el-option
            v-for="(child, index) in type_list"
            :key="index"
            :label="child.label"
            :value="child.value"
          ></el-option>
        </el-select>
        <el-input
          v-model="formInline.phone"
          placeholder="请输入手机号"
          class="handle-input mr10"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch"
          >搜索</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + page_index }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sign_name"
          label="渠道"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="area_code"
          label="国际区号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sms_code"
          label="验证码"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="发送日期"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../../api/smsApiConfig";
export default {
  name: "Msglist",
  data() {
    return {
      formInline: {
        platform_type: "",
        type: "",
      },
      platform_type_list: [
        { value: "", label: "全部" },
        { value: "1", label: "家庭中医馆" },
        { value: "2", label: "中医智库" },
        { value: "3", label: "中医智库网页" },
      ],
      type_list: [
        { value: "", label: "全部" },
        { value: "medicine_login", label: "登录(读古籍)" },
        { value: "login", label: "登录" },
        { value: "register", label: "注册" },
        { value: "forget_pwd", label: "忘记密码" },
        { value: "edit_pwd", label: "修改密码" },
        { value: "edit_mobile", label: "修改手机号" },
        { value: "withdrawal", label: "提现" },
      ],
      code_id: "medicine_login",
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      phone: "",
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      params["phone"] = that.formInline.phone;
      params["platform_type"] = that.formInline.platform_type;
      params["type"] = that.formInline.type;
      http.get("/admin/sms_infos", { params: params }).then(function(res) {
        that.page_index = (that.currentPage - 1) * that.page_size;
        that.tableData = res.data.data.infos;
        that.currentPage = parseInt(res.data.data.current_page);
        that.totalPages = res.data.data.total_pages;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
      });
    },
    handleSelectChange() {
      this.currentPage = 1;
      this.getData();
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
</style>
